import { useState } from 'react';
import { Helmet } from 'react-helmet-async';
// @mui
import { Stack, Container, Typography, Button, Dialog, Grid, Card, Box, styled, Divider, Tabs, Tab } from '@mui/material';
import { useNavigate } from 'react-router-dom'; 
import { signOut } from 'firebase/auth';
import Slider from 'react-slick';
import useGetBusinessById from '../hooks/useGetBusinessById';
import { auth } from '../firebase';
import Label from '../components/label/Label';
import SellItem from '../sections/@dashboard/marketplace/SellItem';
import useGetMarketplaceById from '../hooks/useGetMarketplaceById';
import { fNumber } from '../utils/formatNumber';
import EditItem from '../sections/@dashboard/marketplace/EditItem';
import useGetFavorites from '../hooks/useGetFavorites';
import Business from '../sections/@dashboard/profile/Business';
import MyProfile from '../sections/profile/MyProfile';
import Analytics from '../sections/@dashboard/products/Analytics';
// components
 

function ProfilePage() {
  
  const navigate = useNavigate()
  
  const [open, setOpen] = useState(false);
  const [openEdit, setopenEdit] = useState(false)
  const [selectedItem, setselectedItem] = useState(null)

    const handleClickOpen = () => {
      setOpen(true);
    };
  
    const handleClose = () => {
      setOpen(false);
    };
    
    const handleClickOpenEdit = (ex) => {
      setselectedItem(ex)
      setopenEdit(true);
    };
  
    const handleCloseEdit = () => {
      setopenEdit(false);
    };

    const businesses = useGetBusinessById(auth.currentUser?.uid)
    const market = useGetMarketplaceById(auth.currentUser?.uid)
    const favorites = useGetFavorites(auth.currentUser?.uid)
 
    const StyledProductImg = styled('img')({
      top: 0,
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      position: 'absolute',
    });
    const StyledProductMarket = styled('img')({
      top: 0, bottom:0, left:0, right:0, 
      
    });
    const settings2 = {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      initialSlide: 0,
      
    };

    const [value, setValue] = useState(0);

    const handleChange = (event, newValue) => {
      setValue(newValue);
    };
  return (
    <>
      <Helmet>
        <title> Profile</title>
      </Helmet>
      <Dialog
        open={open}
        onClose={()=>handleClose()}
      ><SellItem handleClose={()=>handleClose()} />
      </Dialog>
      
      <Dialog
        open={openEdit}
        onClose={()=>handleCloseEdit()}
      ><EditItem handleClose={()=>handleCloseEdit()} data={selectedItem} />
      </Dialog>


      {auth.currentUser === null ? 
      <Container>

   
        <Stack justifyContent={"center"} alignContent={"center"}>
          <Typography variant="h2" sx={{textAlign:"center"}}>What we help you with</Typography>
          <Typography variant="body1" sx={{textAlign:"center"}}>Experience a hassle-free way to build your dream home with us!</Typography>
        
          <Stack justifyContent={"center"} alignItems={"center"}> 
          <Button sx={{my:6}} size="large" color="success" onClick={()=>navigate("/login")} variant="contained">Get Started</Button>
          </Stack>

          <Grid container spacing={3} sx={{mt:3}}>
          
          <Grid item xs={12} md={4}>
          <Card sx={{p:4}}>
          <Box>
            <Typography variant='h5' sx={{textAlign:"center"}}>Effortless Home Building</Typography>            
            <Divider sx={{my:6}} />
            <Typography variant='body1' sx={{textAlign:"center"}}>Our platform streamlines the entire home-building journey, from land selection to construction, all in one place. Save time and simplify your path to homeownership.</Typography>
           </Box>
          </Card>
          </Grid>
        
          <Grid item xs={12} md={4}>
          <Card sx={{p:4}}>
          <Box>
            <Typography variant='h5' sx={{textAlign:"center"}}>Trusted Professionals</Typography>            
            <Divider sx={{my:6}} />
            <Typography variant='body1' sx={{textAlign:"center"}}>Discover and connect with reputable architects, builders, and designers. We've curated a network of experts with reviews and portfolios, ensuring your dream home is in good hands.</Typography>
           </Box>
          </Card>
          </Grid>
        
          <Grid item xs={12} md={4}>
          <Card sx={{p:4}}>
          <Box>
            <Typography variant='h5' sx={{textAlign:"center"}}>Budget Bliss</Typography>            
            <Divider sx={{my:6}} />
            <Typography variant='body1' sx={{textAlign:"center"}}>Take control of your finances with our cost tracking tool. Stay on budget, avoid surprises, and confidently manage your home construction expenses.</Typography>
           </Box>
          </Card>
          </Grid>

          </Grid>

        </Stack>
      </Container> : 
      <Container>
       

         <Tabs value={value}  variant="scrollable" onChange={handleChange} sx={{mb:4}}>
        <Tab label="Businesses" />
        <Tab label="Marketplace" />
        <Tab label="Favorites" />
        <Tab label="Profile" />
        {/* <Tab label="Analytics" /> */}
        </Tabs>

{value === 0 && <div>
         <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
         <Typography variant="h6" gutterBottom>
            My Businesses
          </Typography> 
          {businesses?.length >= 1 ? <Typography>You have reached your limit.</Typography> :
           <Button onClick={()=>navigate("/dashboard/addBusiness")} variant='contained' color="success">Add Business</Button>   }
         
         </Stack> 
      <Grid container spacing={3}>
     
      {businesses && businesses.map((b, index)=>(
        <Grid item xs={12} md={3} key={index} onClick={()=>navigate("/dashboard/managePage", {state : b})} >
        <Card>
      <Box sx={{ pt: '100%', position: 'relative' }}>
       
          <Label
            variant="filled"
            color={'info'}
            sx={{
              zIndex: 9,
              top: 16,
              right: 16,
              position: 'absolute',
              textTransform: 'uppercase',
            }}
          >
            {b.category}
          </Label>
      <StyledProductImg alt={b.name} src={b.cover_image} />
      </Box>
      <Stack spacing={2} justifyContent={"space-between"} direction="row" sx={{ p: 3 }}>
          <Typography variant="subtitle2" noWrap>
            {b.name}
          </Typography>
      
              <Typography
              variant="overline"             
            >
        {b.category}
            </Typography>           
         
       </Stack>
    </Card>
        </Grid>
      ))}
      </Grid>
</div>}

{value === 1 && <div>
      <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5} mt={4}>
         <Typography variant="h6" gutterBottom>
            My Marketplace
          </Typography>  
      <Button variant='contained' color='success' onClick={()=>handleClickOpen()}>Sell/Rent Item</Button>  
          </Stack>

          <Grid container spacing={3}>
            {market?.map((m, index)=>(
              <Grid item xs={12} md={4} key={index}>
            <Card onClick={()=>handleClickOpenEdit(m)}>
                <Box>
                <Slider {...settings2}>
                    {m.images?.map((i, index)=>(
                      <StyledProductMarket key={index} alt={m.name} src={i} />
                    ))}
                </Slider>
                    <Stack spacing={2} sx={{p:2}}>
                         <Typography variant="h5">{fNumber(m.price)}
                        <Typography component="span"> {m.type}</Typography></Typography>
                        <Stack direction="row" justifyContent={"space-between"}>
                            <Typography>{m.name}</Typography>
                            <Typography>{m.condition}</Typography>
                        </Stack>
                    </Stack>
                </Box>
            </Card>
        </Grid>
            ))}
            </Grid>
</div>}

{value === 2 && <div>
            <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5} mt={4}>
         <Typography variant="h6" gutterBottom>
            My Favorites
          </Typography>  
      
          </Stack>
            <Grid container spacing={3}>

          {favorites?.map((f, index)=>(
          <Business id={f.item} key={index} />
          ))}
            </Grid>
            </div>}

{value === 3 && <MyProfile />} 
{value === 4 && <Analytics />}
      </Container>}
    </>
  )
}

export default ProfilePage